import { render, staticRenderFns } from "./EventModalStaffPasses.vue?vue&type=template&id=dbcebfcc&scoped=true"
import script from "./EventModalStaffPasses.vue?vue&type=script&lang=js"
export * from "./EventModalStaffPasses.vue?vue&type=script&lang=js"
import style0 from "./EventModalStaffPasses.vue?vue&type=style&index=0&id=dbcebfcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcebfcc",
  null
  
)

export default component.exports